import React from 'react';
import { useParams } from "react-router-dom";
import { IntlProvider, useIntl } from 'react-intl';
import en from '../../international/en.js';
import zh_hk from '../../international/zh-hk.js';
import zh_cn from '../../international/zh-cn.js';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { Provider } from 'react-redux'
import store from "../../redux/store";
import HKIDRForm from './HKIDRForm';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import queryString from 'query-string';
import '../../Content/common.css';
import '../../Content/companysite.css';
import '../../Content/webtrade.css';
import '../../Content/dark.css';

function updateSize() {
  window.parent.postMessage({height:document.body.clientHeight}, "*");    
} 

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  let query = queryString.parse(window.location.search);
  let strPlatform = query["platform"] ?  query["platform"] : "";
  
  let theme = query["theme"] ? query["theme"] : "";
  if(theme){
    document.body.classList.add(theme);    
  }

  if(strPlatform){
    document.body.classList.add(strPlatform);
  }

  if(strPlatform == "KGIWebTrade"){    
    window.addEventListener('resize', updateSize);
    updateSize();
  }
   
  return (
    <div
      component="div"
      role="tabpanel"
      hidden={value !== index}
      className={strPlatform}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function FormMaster() {
  const intl = useIntl();
  let { accountNo } = useParams();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Provider store={store}>
      <Paper square>
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          onChange={handleChange}
        >
          <Tab icon={<BorderColorIcon />}  style={{fontSize: "12px"}} label={intl.formatMessage({ id: 'hkidr.hkidr' })} />         
        </Tabs>
      </Paper>
      <TabPanel value={value} index={0}>
        <HKIDRForm accountNo={accountNo} />
      </TabPanel>
    </Provider>
  );
}

function FormMasterIntl() {
  let { langCode } = useParams();

  return (
    <IntlProvider 
      locale={langCode.includes('zh-HK') ? "zh-hk" : (langCode.includes('zh-CN') ? "zh-cn" : "en")} 
      messages={langCode.includes('zh-HK') ? zh_hk : (langCode.includes('zh-CN') ? zh_cn : en)}
    >
      <FormMaster />
    </IntlProvider>
  );
}

export default FormMasterIntl;
